// Fila / lobby: quem está na sala, contagem regressiva e "Começar" para o dono.
import { forgetRoom, setCurrentRoom } from "../net";
import { navigate, type View } from "../router";
import { gameStore, setGameStore } from "../game/store";
import { esc } from "../ui";
import { mountRoomChat } from "../roomchat";
import { loadSprites, spriteHtml } from "../sprites";
import { t } from "../i18n";
import { currentUser } from "../session";
import { reportButton } from "../report";

export const lobbyView: View = (root) => {
  const store = gameStore();
  if (!store) {
    navigate("/menu");
    return;
  }
  root.innerHTML = `
    <div class="screen">
      <header class="screen__top"><span></span><h1 class="bw-title screen__title">${t("lobby.title")}</h1><span></span></header>
      <main class="screen__body screen__body--center">
        <div class="queue-spinner" aria-hidden="true"></div>
        <p class="queue-time" data-time>--</p>
        <div class="queue-dots" data-dots></div>
        <section class="bw-panel narrow"><div class="bw-panel__header" data-title>${t("lobby.players")}</div><ul class="lobby-list" data-list></ul></section>
        <div class="bw-textbox narrow" data-hint></div>
        <section class="bw-panel narrow"><div class="bw-panel__header">${t("social.roomChat")}</div><div data-chat></div></section>
        <div class="bw-row">
          <button class="bw-btn bw-btn--green" data-start hidden>${t("lobby.start")}</button>
          <button class="bw-btn bw-btn--blue" data-bots hidden title="${t("lobby.fillBotsHint")}">🤖 ${t("lobby.fillBots")}</button>
          <button class="bw-btn bw-btn--red" data-cancel>${t("lobby.leave")}</button>
        </div>
      </main>
    </div>`;

  const $ = <T extends HTMLElement>(s: string) => root.querySelector<T>(s)!;
  const render = () => {
    if (store.started) {
      navigate("/partida");
      return;
    }
    if (store.lastError === "cancelled") {
      $("[data-hint]").textContent = t("lobby.cancelled");
      return;
    }
    const l = store.lobby;
    if (!l) return;
    $("[data-title]").textContent = t("lobby.playersCount", { n: l.players.length, max: l.max });
    $("[data-list]").innerHTML = l.players
      .map((p) => `<li>${spriteHtml(p.avatar ?? 25, 32)}${p.id === l.host ? "👑 " : ""}${esc(p.nickname)}${p.id === store.lobbyId ? ` <span class='bw-dim'>(${t("lobby.you")})</span>` : p.userId && p.userId !== currentUser()?.id ? reportButton(p.userId, p.nickname) : ""}</li>`)
      .join("");
    $("[data-dots]").innerHTML = Array.from({ length: l.max }, (_, i) => `<i class="${i < l.players.length ? "on" : ""}"></i>`).join("");
    const host = store.isHost();
    $("[data-start]").hidden = !host || l.players.length < l.min;
    $("[data-bots]").hidden = !host || l.players.length >= l.max || l.mode === "ranked" || l.mode === "tutorial";
    $("[data-hint]").textContent = host
      ? l.players.length === 1
        ? t("lobby.hint.solo")
        : t("lobby.hint.host")
      : t("lobby.hint.wait");
  };
  const tick = setInterval(() => {
    const l = store.lobby;
    if (!l) return;
    const s = Math.max(0, Math.ceil((l.startsAt - Date.now()) / 1000));
    $("[data-time]").textContent = `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
  }, 250);
  const unsubChat = mountRoomChat($("[data-chat]"), store);
  const unsub = store.subscribe(render);
  render();
  void loadSprites().then(render);

  $("[data-start]").addEventListener("click", () => store.start());
  $("[data-bots]").addEventListener("click", () => store.start(true));
  $("[data-cancel]").addEventListener("click", async () => {
    await store.room.leave(true).catch(() => {});
    forgetRoom();
    setCurrentRoom(null);
    setGameStore(null);
    navigate("/menu");
  });

  return () => {
    clearInterval(tick);
    unsub();
    unsubChat();
  };
};
